<template>
  <div v-if="!selecionouImportacao">
    <div class="importacao-content" v-for="alerta in alertasFiltrados">
      <QuadroAlertaZfm :alerta="alerta" />
    </div>
    <div class="importacao-content" v-for="subimposto in dadosImportacao">
      <RadioButton
        v-if="dadosImportacao.length > 1 && subimposto.desabilita != 1"
        :seleciona="seleciona"
        :imposto="subimposto"
        :classe="imposto.classe"
      />
      <!-- registros que devem ser desabilitados para seleção tem a propriedade "desabilita" igual a 1  -->
      <Registro
        
        :class="[subimposto.desabilita == 1 ? 'padding-sem-checkbox' : '']"
        :desabilitado="subimposto.desabilita == 1"
        :paddingSemCheckBox="dadosImportacao.length <= 1"
      >
        <Cabecalho :titulo="subimposto.label" :aliquota="subimposto.aliquota" />
        <div class="separador" />

        <Cabecalho
          v-if="subimposto.aliquota_efetiva && !subimposto.aliquota"
          :titulo="'Alíquota'"
          :aliquota="subimposto.aliquota_efetiva"
        />
        <div v-if="subimposto.aliquota_efetiva && !subimposto.aliquota" class="separador" />

        <Ncm :ncm="subimposto.ncm" />
        <div v-if="subimposto.ncm" class="separador" />

        <Descricao :titulo="'Descrição'" :descricao="subimposto.descricao" />
        <div v-if="subimposto.descricao" class="separador" />

        <Cabecalho v-if="subimposto.bit_bk" :titulo="'Tipo'" :aliquota="subimposto.bit_bk" />
        <div v-if="subimposto.bit_bk" class="separador" />

        <Cabecalho
          v-if="subimposto.vigencia_fim"
          :tipo="'data'"
          :titulo="'Vigência'"
          :aliquota="subimposto.vigencia_fim"
        />
        <div v-if="subimposto.vigencia_fim" class="separador" />

        <Notificacao
          v-if="!!subimposto.alerta_excecao"
          :tipo="'alerta'"
          :texto="subimposto.alerta_excecao"
        />
        <GrupoNotificacao
          v-if="subimposto"
          :municipios="subimposto.aplicavel_municipios"
          :registro="subimposto"
        />
        <div
          v-if="
            (subimposto.alerta_excecao ||
              subimposto.obs_aplic ||
              subimposto.obs_inaplic ||
              subimposto.obs) &&
              (subimposto.base_legal || subimposto.acordo)
          "
          class="separador"
        />

        <div v-if="subimposto.acordo">
          <Cabecalho class="cabecalho-acordo" :titulo="'Acordo Comercial'" />
          <Registro>
            <AcordoComercial :dados="subimposto" :classe="imposto.classe" />
          </Registro>
          <div v-if="subimposto.acordo && subimposto.base_legal" class="separador" />
        </div>

        <BaseLegal :base_legal="subimposto.base_legal" :classe="imposto.classe" />
      </Registro>
    </div>
  </div>

  <div v-else>
    <div class="importacao-content" v-for="alerta in alertasFiltrados">
      <QuadroAlertaZfm :alerta="alerta" />
    </div>
    <div class="importacao-content">
      <EditButton v-if="dadosImportacao.length > 1" :edita="edita" :classe="imposto.classe" />
      <div class="importacao-registro-container">
        <Registro :paddingSemCheckBox="dadosImportacao.length <= 1">
          <Cabecalho :titulo="registroSelecionado.label" :aliquota="registroSelecionado.aliquota" />
          <div class="separador" />

          <Cabecalho
            v-if="registroSelecionado.aliquota_efetiva && !registroSelecionado.aliquota"
            :titulo="'Alíquota'"
            :aliquota="registroSelecionado.aliquota_efetiva"
          />
          <div
            v-if="registroSelecionado.aliquota_efetiva && !registroSelecionado.aliquota"
            class="separador"
          />

          <Ncm :ncm="registroSelecionado.ncm" />
          <div v-if="registroSelecionado.ncm" class="separador" />

          <Descricao :titulo="'Descrição'" :descricao="registroSelecionado.descricao" />
          <div v-if="registroSelecionado.descricao" class="separador" />

          <Cabecalho
            v-if="registroSelecionado.bit_bk"
            :titulo="'Tipo'"
            :aliquota="registroSelecionado.bit_bk"
          />
          <div v-if="registroSelecionado.bit_bk" class="separador" />

          <Cabecalho
            v-if="registroSelecionado.vigencia_fim"
            :tipo="'data'"
            :titulo="'Vigência'"
            :aliquota="registroSelecionado.vigencia_fim"
          />
          <div v-if="registroSelecionado.vigencia_fim" class="separador" />

          <Notificacao
            v-if="!!registroSelecionado.alerta_excecao"
            :tipo="'alerta'"
            :texto="registroSelecionado.alerta_excecao"
          />
          <GrupoNotificacao
            :municipios="registroSelecionado.aplicavel_municipios"
            v-if="registroSelecionado"
            :registro="registroSelecionado"
          />
          <div
            v-if="
              (registroSelecionado.alerta_excecao ||
                registroSelecionado.obs_aplic ||
                registroSelecionado.obs_inaplic ||
                registroSelecionado.obs) &&
                (registroSelecionado.base_legal || registroSelecionado.acordo)
            "
            class="separador"
          />

          <div v-if="registroSelecionado.acordo">
            <Cabecalho class="cabecalho-acordo" :titulo="'Acordo Comercial'" />
            <Registro>
              <AcordoComercial :dados="registroSelecionado" :classe="imposto.classe" />
            </Registro>
            <div
              v-if="registroSelecionado.acordo && registroSelecionado.base_legal"
              class="separador"
            />
          </div>

          <BaseLegal :base_legal="registroSelecionado.base_legal" :classe="imposto.classe" />
        </Registro>
        <Registro colorido :classe="imposto.classe" v-if="registroSelecionado.preferencia" class="aliquota-efetiva">
          <Cabecalho
            :titulo="'Alíquota Efetiva'"
            :aliquota="registroSelecionado.aliquota_efetiva"
          />
        </Registro>
      </div>
    </div>
  </div>
</template>

<script>
import AcordoComercial from "@/components/AcordoComercial/AcordoComercial.vue";
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";
import QuadroAlertaZfm from "@/components/QuadroAlertaZfm/QuadroAlertaZfm.vue";

export default {
  name: "RegistrosImportacao",

  props: {
    imposto: Array | Object,
    seleciona: Function,
    edita: Function,
    registroSelecionado: Object,
    selecionouImportacao: Boolean
  },

  components: {
    AcordoComercial,
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    Ncm,
    GrupoNotificacao,
    Notificacao,
    RadioButton,
    Registro,
    QuadroAlertaZfm
  },

  data() {
    return {};
  },

  created() {
    if (this.imposto && this.dadosImportacao.length == 1) {
      this.seleciona(this.dadosImportacao[0]);
    }
  },

  mounted() {},

  computed: {
    dadosImportacao() {
      let dados = this.imposto.dados.filter(imposto => imposto.ordem != 101);
      return dados;
    },
    alertasFiltrados() {
      let dados = this.imposto.dados.filter(imposto => imposto.ordem == 101);
      return dados;
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.importacao-content {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
.cabecalho-acordo {
  margin-bottom: 1rem;
}
.aliquota-efetiva {
  margin-top: 0.8rem;
}
.importacao-registro-container {
  width: 100%;
}
</style>
